// extracted by mini-css-extract-plugin
export default {"ForgotPassword__gridItem":"ForgotPassword_ForgotPassword__gridItem__3qS6t","ForgotPassword":"ForgotPassword_ForgotPassword__UBaSr"};